var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFirstAidKit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46.7 46.7",
    style: {
      enableBackground: "new 0 0 46.7 46.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#A32F88;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#7C80A4;stroke-linecap:round;}\r\n\t.st2{fill:none;stroke:#A32F88;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.1,
    y1: 15.3,
    x2: 19.6,
    y2: 19.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.2,18.9c2.6-5.9-0.1-12.7-5.9-15.3c-4.4-1.9-9.5-1-12.9,2.4L5.7,24.6C1.1,29,0.9,36.4,5.4,41 c4.4,4.6,11.8,4.8,16.4,0.4c0.1-0.1,0.3-0.3,0.4-0.4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32.8,
    cy: 32.6,
    r: 11.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_405"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Linie_3",
    className: "st1",
    points: "38.2,29.2 31.4,36 27.8,32.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Linie_3-2",
    className: "st2",
    points: "38.2,29.2 31.4,36 27.8,32.5  "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_00000132804282030251800430000008950360516367126449_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2_00000100380885590497790250000003775024589897097133_"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.1,
    y1: 15.1,
    x2: 19.6,
    y2: 19.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.2,18.7c2.6-5.9-0.1-12.7-5.9-15.3c-4.4-1.9-9.5-1-12.9,2.4L5.7,24.4c-4.6,4.4-4.8,11.8-0.4,16.4 c4.4,4.6,11.8,4.8,16.4,0.4c0.1-0.1,0.3-0.3,0.4-0.4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32.8,
    cy: 32.4,
    r: 11.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_405_00000024691274441913360750000010209204393893064633_"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Linie_3_00000139275977727567501090000004636777674554852747_",
    className: "st1",
    points: "38.2,29 31.4,35.8 27.8,32.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Linie_3-2_00000034090929303354623630000003863057133439093926_",
    className: "st2",
    points: "38.2,29 31.4,35.8 27.8,32.2  "
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFirstAidKit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/first-aid-kit.6c2347b1.svg";
export { ForwardRef as ReactComponent };